<template>
  <div>
    <activityTable
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :currentPage="currentPage"
      :countObjData="countObjData"
      :perPage="perPage"
      @search="onSearch"
      @changepage="onChangePage"
      :loadBtnExport="loadBtnExport"
      @exportAlumniActivity="exportAlumniActivity"
      @updateObjMainActivity="updateObjMainActivity"
    />
  </div>
</template>

<script>
import activityTable from "./ActivityTable.vue";
import _excelReport from "../excel-report/headerexcel.js";

const tableColumns = [
  {
    title: "Date of Activity",
    width: 100,
    dataIndex: "date_of_activity",
    scopedSlots: { customRender: "date_of_activity" },
    fixed: "left",
    className: "center-colum column-header-activity",
  },
  {
    title: "Activity Name",
    width: 200,
    dataIndex: "name_of_activity",
    scopedSlots: { customRender: "name_of_activity" },
    fixed: "left",
    className: "center-colum column-header-activity",
  },
  // {
  //   title: "Type activity",
  //   dataIndex: "type_of_activity_detail.name_eng",
  //   scopedSlots: { customRender: "type_of_activity_detail.name_eng" },
  //   className: "center-colum column-header-activity-sub",
  // },
  // {
  //   title: "Activity Other",
  //   dataIndex: "type_of_activity_other",
  //   scopedSlots: { customRender: "type_of_activity_other" },
  //   className: "center-colum column-header-activity-sub",
  // },
  {
    title: "Organized By",
    dataIndex: "organized_by",
    scopedSlots: { customRender: "organized_by" },
    className: "center-colum column-header-activity-sub",
  },
  {
    title: "Location",
    dataIndex: "location",
    scopedSlots: { customRender: "location" },
    className: "center-colum column-header-activity-sub",
  },
  {
    title: "No. of Participants",
    dataIndex: "no_of_participants",
    scopedSlots: { customRender: "no_of_participants" },
    className: "center-colum column-header-activity-sub",
  },
  {
    title: "No. of Alumni",
    dataIndex: "amount_user",
    scopedSlots: { customRender: "amount_user" },
    className: "center-colum column-header-activity-sub",
  },
  // {
  //   title: "Budget",
  //   dataIndex: "budget",
  //   scopedSlots: { customRender: "budget" },
  //   className: "center-colum column-header-activity-sub",
  // },
  // {
  //   title: "Income",
  //   dataIndex: "income",
  //   scopedSlots: { customRender: "income" },
  //   className: "center-colum column-header-activity-sub",
  // },
  // {
  //   title: "Item",
  //   dataIndex: "Item",
  //   scopedSlots: { customRender: "Item" },
  //   className: "center-colum column-header-activity-sub",
  // },
  {
    title: "Action",
    key: "Action",
    fixed: "right",
    width: 150,
    scopedSlots: { customRender: "Action" },
    className: "center-colum column-header-activity",
  },
];
export default {
  components: {
    activityTable,
  },
  data() {
    return {
      tableData: [],
      tableColumns,
      loading: false,
      // pagination
      perPage: 10,
      countObjData: 0,
      currentPage: 1,
      offset: 0,
      // export data : _excelReport
      dataFilter: {},
      loadBtnExport: false,
      headExcelAlumniData: _excelReport.reportD,
      dataExcel: [],
    };
  },
  mounted() {
    this.getActivityData();
  },
  methods: {
    onSearch(...args) {
      this.dataFilter = Object.assign({}, args[0].dataQuery);
      // //console.log(this.dataFilter)
      this.currentPage = 1;
      this.offset = 0;
      this.getActivityData();
    },
    onChangePage(...args) {
      this.currentPage = args[0].currentPage;
      this.offset = args[0].currentPage;
      this.getActivityData();
    },
    async getActivityData() {
      this.tableData = [];
      this.loading = true;
      try {
        let url
        if (Object.keys(this.dataFilter).length != 0) {
         url =  `/student_affair/alumni-activity/?limit=${this.perPage}&offset=${this.offset}&search=${this.dataFilter?this.dataFilter.searchText:''}`
        } else {
          url =  `/student_affair/alumni-activity/?limit=${this.perPage}&offset=${this.offset}`
        }
        const res = await this.$http.get(url);
        if (res.status === 200) {
          this.tableData = res.data.results.map((item) => ({ ...item }));
          this.countObjData = res.data.count;
          this.offset = 0;
          this.loading = false;
        } else {
          throw { res };
        }
      } catch (error) {
        this.tableData = [];
        this.$notification['error']({
          message: function (h) {
            return h("div", [
            h("strong", { class: "" }, `Failed to connect to the API`),
            ]);
          },
          description:
          `Error ${error.response.status} : /student_affair/alumni-activity/`,
        });
        this.loading = false;
      }
    },
    async exportAlumniActivity() {
      this.loadBtnExport = true;
      this.dataExcel = [];
        if (this.tableData.length > 0) {
        this.dataExcel = this.tableData.map((item) => ({
            A: item.id,
            B: `${_excelReport.printFormatData(
              item.date_of_activity,
              "string",
              ""
            )}`,
            C: `${_excelReport.printFormatData(
              item.name_of_activity,
              "string",
              ""
            )}`,
            D: `${_excelReport.printFormatData(
              item.organized_by,
              "string",
              ""
            )}`,
            E: `${_excelReport.printFormatData(item.location, "string", "")}`,
            F: `${_excelReport.printFormatData(
              item.amount_user,
              "string",
              ""
            )}`,
          }));
          // create excle file
          const wb = this.XLSX.utils.book_new();
          const data = this.XLSX.utils.json_to_sheet(
            this.headExcelAlumniData.concat(this.dataExcel),
            {
              header: _excelReport.mainExcel,
              skipHeader: true,
            }
          );
          this.XLSX.utils.book_append_sheet(wb, data, "List-activity-data");
          this.XLSX.writeFile(wb, "Activity_Data.xlsx");
          this.loadBtnExport = false;
        } else {
        this.loadBtnExport = false;
        this.$notification['error']({
          message: function (h) {
            return h("div", [
            h("strong", { class: "" }, `Can't export to excel file`),
            ]);
          },
          description:
          `Data table not fond.`,
        });
      }
    },
    updateObjMainActivity(...args){
      const indexID = this.tableData.findIndex(
        (item) => item.id === args[0].data.id
      );
      let arrSlotUp = [];
      arrSlotUp.push(args[0].data);
      this.tableData.splice(indexID, 1, arrSlotUp[0]);
    }
  },
};
</script>

<style>
.center-colum {
  text-align: center !important;
  font-weight: 700 !important;
}

th.column-header-activity {
  background-color: #23355c !important;
  color: #ffffff !important;
}

th.column-header-activity-sub {
  background-color: #b7c4cf !important;
  color: #000000 !important;
}
</style>